function isAdminPath(path: string) {
  // /admin/... or /en/admin/... (i18n prefix_except_default)
  return /^(\/[a-z]{2})?\/admin(\/|$)/.test(path)
}

function isAdminLoginPath(path: string) {
  return /^(\/[a-z]{2})?\/admin\/login\/?$/.test(path)
}

export default defineNuxtRouteMiddleware(async (to) => {
  if (!isAdminPath(to.path)) return

  const localePath = useLocalePath()
  const loginPath = localePath('/admin/login')

  // Already on login page: if logged in, go dashboard; otherwise allow
  if (isAdminLoginPath(to.path)) {
    try {
      await $fetch('/api/auth/me')
      return navigateTo(localePath('/admin/dashboard'))
    } catch {
      return
    }
  }

  try {
    await $fetch('/api/auth/me')
  } catch {
    return navigateTo({
      path: loginPath,
      query: {
        redirect: to.fullPath,
      },
    }) 
  }
})
